"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMemberById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a member by given member ID.
 *
 * Member is identified by their Discord ID.
 *
 * ### Updatable fields
 * - `description`
 *
 * ## Usage
 *
 * ```ts
 * const memberId: string = "2938274356793";
 * const member: Member = {
 * 	description: "Lorem ipsum dolor sit amet.",
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateMemberById({ memberId, member });
 * ```
 *
 * @param params.memberId - ID of the member to update.
 * @param params.member   - Fields to be updated for selected member.
 */
const updateMemberById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { member, memberId } = params;
    const url = `${BASE_URL}/members/member/${memberId}`;
    const memberResponse = yield axios_1.default.put(url, member, { validateStatus: () => true });
    const { status, data } = memberResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateMemberById = updateMemberById;
